import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const raiffeisenImpulsDe = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe":
        "Raiffeisen-IMPULS Leasing Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>{{organization}}<br>Werkstatt-Buchung</strong>",
      },
      layout: {
        navbar: {
          partnerLogo: {
            alt: "Raiffeisen-IMPULS Leasing",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/raiffeisen-impuls-de",
      contact: {
        raiffeisen: {
          hotline: {
            label: "24h Pannen und Schadenhotline",
            phone: { title: "+49 (0) 800/0500 511", link: "tel:+498000500511" },
          },
          damageManagement: {
            label: "Schadenmanagement",
            phone: {
              title: "+49 (0) 8106/99735-18 747",
              link: "tel:+4981069973518747",
            },
            email: {
              title: "schaden@ril-fuhrpark.de",
              link: "mailto:schaden@ril-fuhrpark.de",
            },
          },
          maintenance: {
            label: "Wartung & Verschleiß / Reifen / Tankkarten",
            phone: {
              title: "+49 (0) 8106/99735-18 748",
              link: "tel:+4981069973518748",
            },
            email: {
              title: "service@ril-fuhrpark.de",
              link: "mailto:service@ril-fuhrpark.de",
            },
          },
          vehicleReturn: {
            label: "Fahrzeugrückgabe",
            phone: {
              title: "+49 (0) 8106/99735-18 755",
              link: "tel:+4981069973518755",
            },
            email: {
              title: "logistik@ril-fuhrpark.de",
              link: "mailto:logistik@ril-fuhrpark.de",
            },
          },
        },
      },
    },
  },
};
